module.exports = __webpack_public_path__ + "img/mobile-banner1-vn.c6ba17ea.jpg";